import React from "react";
import Contentify from "../../content/Contentify";
import Store from "../../content/Store";
import LabelWithTooltip from "../shared/label/LabelWithTooltip";

export const MembershipNumberInput = ({ onChange, mfa, content }) => (
  <div className="form-group">
    <LabelWithTooltip label={content.label} tooltipContent={content.tooltip} mfa={mfa}/>
    <input
      className="form-control"
      type="text"
      name="membershipNumber"
      placeholder={content.placeholder}
      onChange={onChange}
    ></input>
  </div>
);

MembershipNumberInput.content = Store.MembershipNumber;

export default Contentify(MembershipNumberInput);
